import { useCallback, useMemo } from "react";
import { isNull } from "lodash";

import { useQuery } from "hooks";

import { computeFieldValue } from "scenes/Hubly/components/Workspace/api";

import toGlobalId from "../../../api/helper";

export function useFields(formId) {
  const factory = useCallback(() => {
    const query = `query getFormInstance($id: ID!) {
      formInstance(id: $id) {
        id
        isFilled
        name
        task {
          title
          clientWorkflow {
            name
            client {
              name
            }
          }
        }
        fieldValues {
          edges {
            node {
              id
              name
              options
              type {
                id
                text
                showOptions
              }
              dataType
              value {
                ... on StringValue {
                  stringValue
                }
                ... on BooleanValue {
                  booleanValue
                }
                ... on DateTimeValue {
                  datetimeValue
                }
                ... on ArrayStringValue {
                  arrayStringValue
                }
              }
              required
              description
              defaultValue {
                ... on StringValue {
                  stringValue
                }
                ... on BooleanValue {
                  booleanValue
                }
                ... on DateTimeValue {
                  datetimeValue
                }
                ... on ArrayStringValue {
                  arrayStringValue
                }
              }
            }
          }
        }
      }
    }`;

    const resolver = ({ data: { formInstance } }) => {
      return [
        {
          taskTitle: formInstance?.task?.title,
          workflowName: formInstance?.task?.clientWorkflow?.name,
          clientName: formInstance?.task?.clientWorkflow?.client?.name,
          formName: formInstance?.name,
          isFormFilled: formInstance?.isFilled,
        },
        formInstance?.fieldValues?.edges.map(({ node }) => {
          return {
            ...node,
            value: computeFieldValue(node.value, node.dataType),
            defaultValue: computeFieldValue(node.defaultValue, node.dataType),
          };
        }),
      ];
    };

    return { query, resolver };
  }, []);

  const {
    data: [task, fields = []],
    loading,
  } = useQuery(factory, {
    variables: useMemo(() => {
      return { id: toGlobalId("FormInstance", formId) };
    }, [formId]),
  });

  return {
    fields: fields,
    task: task,
    loading: loading,
    defaultValues: fields
      .filter(({ value }) => {
        return !isNull(value);
      })
      .reduce((d, { id, value }) => {
        return { ...d, [id]: value };
      }, {}),
  };
}

export default useFields;
